export default "__VITE_ASSET__DkaDqx6J__"